import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import Fade from 'react-reveal/Fade'

import tt from '../../img/MansoryMesh/ball.webp'

function PhysicalAndMechanical () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto relative">
                <div className="flex items-center justify-center">
                    <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center leading-[1.4]">
                        <Trans>{t("mansorymesh.add.12")}</Trans>
                    </p>
                </div>
                <div className='xl:mt-[65px] flex flex-col relative'>
                    <Fade delay={1300}><img src={tt} alt="" className='xl:absolute mt-[45px] xl:mt-0 xl:py-0 px-[50px] sm:px-[150px] md:px-[250px] xl:px-0 left-1/2 xl:!-translate-x-1/2 top-[100px] object-cover w-full h-full xl:w-auto xl:h-auto'/></Fade>
                    <div className='xl:flex justify-between xl:justify-normal hidden'>
                        <Fade left delay={200}><div className='sm:mx-auto flex flex-col items-start max-w-[155px] md:max-w-max'>
                            <div className='max-w-[334px] xl:ml-[49px]'>
                                <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('mansorymesh.30')}</p>
                                <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('mansorymesh.31')}</Trans></p>
                            </div>
                            <div className='flex flex-row gap-[8px] md:gap-[24px] items-center'>
                                <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522] hidden xl:block'></div>
                                <div className='h-px w-[155px] xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                            </div>
                        </div></Fade>
                        <Fade right delay={400}><div className='sm:mx-auto flex flex-col items-end max-w-[155px] md:max-w-max'>
                            <div className='max-w-[334px] xl:mr-[49px]'>
                                <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('mansorymesh.32')}</p>
                                <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('mansorymesh.33')}</Trans></p>
                            </div>
                            <div className='flex flex-row-reverse gap-[8px] md:gap-[24px] items-center'>
                                <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522] hidden xl:block'></div>
                                <div className='h-px w-[155px] xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                            </div>
                        </div></Fade>
                    </div>
                    <div className='hidden xl:flex justify-between xl:mt-[40px]'>
                        <Fade left delay={600}><div className='flex flex-col items-start max-w-[155px] md:max-w-max'>
                            <div className='max-w-[334px] xl:ml-[49px]'>
                                <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('mansorymesh.34')}</p>
                                <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('mansorymesh.35')}</Trans></p>
                            </div>
                            <div className='flex flex-row gap-[8px] md:gap-[24px] items-center'>
                                <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522] hidden xl:block'></div>
                                <div className='h-px w-[155px] xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                            </div>
                        </div></Fade>
                        <Fade right delay={800}><div className='flex flex-col items-end max-w-[155px] md:max-w-max'>
                            <div className='max-w-[334px] xl:mr-[49px]'>
                                <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('mansorymesh.36')}</p>
                                <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('mansorymesh.37')}</Trans></p>
                            </div>
                            <div className='flex flex-row-reverse gap-[8px] md:gap-[24px] items-center'>
                                <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522] hidden xl:block'></div>
                                <div className='h-px w-[155px] xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                            </div>
                        </div></Fade>
                    </div>
                    
                </div>
                <div className='xl:hidden grid grid-cols-2 mt-[30px] gap-x-[20px] gap-y-[10px]'>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('mansorymesh.30')}</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('mansorymesh.31')}</Trans></p>
                    </div>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('mansorymesh.32')}</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('mansorymesh.33')}</Trans></p>
                    </div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('mansorymesh.34')}</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('mansorymesh.35')}</Trans></p>
                    </div>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('mansorymesh.36')}</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('mansorymesh.37')}</Trans></p>
                    </div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                </div>
            </div>
        </div>
    );
}

export default PhysicalAndMechanical;